export const AUTH_SIGN_IN_FETCH = 'auth/SIGN_IN_FETCH';
export const AUTH_SIGN_IN_DATA = 'auth/SIGN_IN_DATA';
export const AUTH_SIGN_IN_ERROR = 'auth/SIGN_IN_ERROR';

export const AUTH_SIGN_UP_DATA = 'auth/SIGN_UP_DATA';
export const AUTH_SIGN_UP_FETCH = 'auth/SIGN_UP_FETCH';
export const AUTH_SIGN_UP_ERROR = 'auth/SIGN_UP_ERROR';
export const AUTH_SIGN_UP_REQUIRE_VERIFICATION = 'auth/SIGN_UP_REQUIRE_VERIFICATION';

export const AUTH_VERIFICATION_FETCH = 'auth/VERIFICATION_FETCH';
export const AUTH_VERIFICATION_SUCCESS = 'auth/VERIFICATION_SUCCESS';

export const AUTH_LOGOUT_FETCH = 'auth/LOGOUT_FETCH';
export const AUTH_LOGOUT_FAILURE = 'auth/LOGOUT_FAILURE';

export const AUTH_TEST_STATE = 'auth/TEST_AUTH_STATE';

export const AUTH_ENTROPY_PASSWORD_FETCH = 'auth/ENTROPY_PASSWORD_FETCH';
export const AUTH_ENTROPY_PASSWORD_DATA = 'auth/ENTROPY_PASSWORD_DATA';
export const AUTH_ENTROPY_PASSWORD_ERROR = 'auth/ENTROPY_PASSWORD_ERROR';


export const LOGIN_GOOGLE_FETCH = 'auth/LOGIN_GOOGLE_FETCH';
export const LOGIN_GOOGLE_DATA = 'auth/LOGIN_GOOGLE_DATA';
